export const getSlotKey = (slot)=>{
    if (!slot?.startDate || !slot?.endDate) {
        return '';
    }
    return `${slot?.startDate}_${slot?.endDate}`;
};
export const formatTimeRange = ({ locale, endDate, startDate, timezone })=>{
    const options = {
        hour: 'numeric',
        minute: 'numeric',
        timeZone: timezone
    };
    const startTime = new Intl.DateTimeFormat(locale, options).format(new Date(startDate));
    const endTime = new Intl.DateTimeFormat(locale, options).format(new Date(endDate));
    return `${startTime} - ${endTime}`;
};
export const getFormattedDateLabel = ({ selectedDate, locale, timezone })=>{
    if (!selectedDate) {
        return '';
    }
    return new Intl.DateTimeFormat(locale, {
        weekday: 'long',
        month: 'short',
        day: 'numeric',
        timeZone: timezone
    }).format(selectedDate);
};
export const getSlotByKey = (key, availabilitySlots)=>{
    return availabilitySlots.find((slot)=>getSlotKey({
            startDate: slot?.slot?.startDate,
            endDate: slot?.slot?.endDate
        }) === key);
};
export const getSlotIndex = (key, availabilitySlots)=>{
    let index;
    availabilitySlots.forEach((slot, i)=>{
        if (getSlotKey({
            startDate: slot?.slot?.startDate,
            endDate: slot?.slot?.endDate
        }) === key) {
            index = i;
        }
    });
    return index;
};

//# sourceMappingURL=utils.js.map